import { httpRequest } from 'http'

export const REQUEST = 'locale/REQUEST'
export const SUCCESS = 'locale/SUCCESS'
export const ERROR = 'locale/ERROR'

export function startRequest() {
    return {
        type: REQUEST,
        payload: {},
    }
}

export function requestSuccess(language, messages) {
    return {
        type: SUCCESS,
        payload: {
            messages,
            language,
        },
    }
}
export function requestError(errorMessage) {
    return {
        type: ERROR,
        payload: {
            errorMessage,
        },
    }
}

export function requestLocale(language) {
    return async (dispatch, getState) => {
        if (getState().locale.loading) return
        dispatch(startRequest())
        httpRequest(`/locale/${language}.json?version=${WGSH_VERSION}`)
            .then(
                resp => dispatch(requestSuccess(language, resp[language])),
                errorData => dispatch(requestError(errorData.errorMessage))
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/locale.js